var _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGeminiSparkleBlue33C17E77C4Ebbdd9490B683B9812247E257B6F70(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20 10.0196C14.6358 10.3431 10.3431 14.6358 10.0196 20H9.98042C9.65687 14.6358 5.36425 10.3431 0 10.0196V9.98043C5.36425 9.65689 9.65687 5.36424 9.98042 0H10.0196C10.3431 5.36424 14.6358 9.65689 20 9.98043V10.0196Z",
    fill: "url(#paint0_radial_809_12024)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_809_12024",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(1.98483 8.12823) rotate(18.6832) scale(21.2875 170.526)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0671246,
    stopColor: "#9168C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.342551,
    stopColor: "#5684D1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.672076,
    stopColor: "#1BA1E3"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGeminiSparkleBlue33C17E77C4Ebbdd9490B683B9812247E257B6F70);
export default __webpack_public_path__ + "static/media/gemini_sparkle_blue_33c17e77c4ebbdd9490b683b9812247e257b6f70.2834624d31a4c33b1d881267b23cf3e6.svg";
export { ForwardRef as ReactComponent };